import { combineReducers } from 'redux';
import { verify } from './verify_reducer';

const rootReducer = combineReducers({
  verify
});

export default rootReducer;
